import { useEffect } from 'react';
import { useLocation } from 'react-router';
declare global {
  interface Window {
    _paq: any;
  }
}
export const useMatomoTracking = () => {
  const location = useLocation().pathname;
  useEffect(() => {
    window._paq = window._paq || [];
    window._paq.push([
      'setTrackerUrl',
      'https://apps-france-challenges.matomo.cloud/matomo.php'
    ]);
    window._paq.push(['setSiteId', '3']);
    window._paq.push(['enableLinkTracking']);
    window._paq.push(['setCustomUrl', '/' + location.slice(1)]);
    window._paq.push(['trackPageView']);

    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://apps-france-challenges.matomo.cloud/matomo.js';
    document.body.appendChild(script);
    console.log('Initialisation Matomo ✅');
  }, [location]);

  return null;
};
